import {
  FolderOpenOutlined,
  LaptopOutlined,
  NotificationOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

export const menuItems = [
  // {
  //   key: "user",
  //   icon: <UserOutlined />,
  //   title: "User",
  //   children: [
  //     { key: "/admin/profile", label: "Profile" },
  //     { key: "/admin/settings", label: "Settings" },
  //     { key: "/admin/officer", label: "Officer" },
  //   ],
  // },
  {
    key: "dashboard",
    icon: <LaptopOutlined />,
    title: "Dashboard",
    children: [
      { key: "/admin/dashboard", label: "Overview" },
      // { key: "/admin/status", label: "Status" },
    ],
  },
  {
    key: "pages",
    icon: <FolderOpenOutlined />,
    title: "Pages",
    children: [
      "olmms-dashboard",
      "olgprs-dashboard",
      "ocmms-dashboard",
      "biomedical-dashboard",
      "ohs-dashboard",
      "aqi-dashboard",
      "software",
    ].map((page) => ({
      key: `/admin/${page}`,
      label: page.replace("-", " ").toUpperCase(),
    })),
  },
  // {
  //   key: "notifications",
  //   icon: <NotificationOutlined />,
  //   title: "Notifications",
  //   children: [
  //     { key: "/admin/all", label: "All Notifications" },
  //     { key: "/admin/settings", label: "Settings" },
  //   ],
  // },
  {
    key: "master",
    icon: <NotificationOutlined />,
    title: "Master",
    children: [
      "District",
      "Taluk",
      "designation",
      "Dee",
      "Flying-Squad",
      // "Village",
      // "Zoneoffice",
      "Complaints",
      "User",
      "Software-Info",
    ].map((item) => ({
      key: `/admin/${item}`,
      label: item.replace("-", " ").toUpperCase(),
    })),
  },
  {
    key: "reports",
    icon: <FileTextOutlined />,
    title: "Overall Reports",
    children: [
      { key: "/admin/district-wise", label: "District Wise" },
      { key: "/admin/zone-wise", label: "Zone Wise" },
      // { key: "/admin/status", label: "Status" },
    ],
  },
];
